// extracted by mini-css-extract-plugin
export default {"wrapper":"RatingQuestion_wrapper__8fXm3","header":"RatingQuestion_header__T0oVV","controls":"RatingQuestion_controls__Wn0sO"};